import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "../../../../lib/styled";
import type { ReactNode } from "react";

interface StatisticProps {
  label: ReactNode;
  /** Render the value in a monospace face — for numeric readouts. */
  mono?: boolean;
  /** The value. */
  children: ReactNode;
}

const Value = styled(Typography)<{ $mono: boolean }>(({ $mono }) => ({
  ...($mono && { fontFamily: "monospace" }),
}));

/** A single labelled readout: a prominent value above a small muted caption. */
export function Statistic({ label, mono = false, children }: StatisticProps) {
  return (
    <Stack>
      <Value variant="h6" component="div" $mono={mono}>
        {children}
      </Value>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Stack>
  );
}
